/**
 * Custom PO Number Saver for both Drawer and Main Cart Page
 */
const initPOSaver = () => {
  document.addEventListener('change', function(evt) {
    // This now checks for BOTH the drawer ID and the main cart ID
    const isPONumberField = evt.target.id === 'CartDrawer-PONumber' || evt.target.id === 'po-number';
    
    if (evt.target && isPONumberField) {
      const poValue = evt.target.value;
      
      const cartForm = document.querySelector('cart-form');
      if (cartForm) cartForm.classList.add('cart-form--refreshing');

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'PONumber': poValue }
        })
      })
      .then(response => response.json())
      .then(data => console.log('PO Saved:', poValue))
      .catch(error => console.error('Error saving PO:', error))
      .finally(() => {
        if (cartForm) cartForm.classList.remove('cart-form--refreshing');
      });
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPOSaver);
} else {
  initPOSaver();
}